module.exports = __webpack_public_path__ + "static/media/light-theme-stops.a4b077a3.svg";